<template>
    <Row class="flex w-full justify-start items-center">
        <Col class="flex-auto text-left ">
            <span class="text-link block">{{ value ? value.id: 0 }} : </span>
        </Col>
        <Col class="flex-auto">
            <AutoComplete
                clearable
                v-model="search_key"
                :placeholder="placeholder || '搜索'"
                @on-change = "onChange"
                @on-blur  = 'blur'
                @on-focus = 'focus'
                :class="classname"
            >
                <Option v-for="option in datas" :value="option.name" :tag="option.id" :key="option.id" @click.native="onClicked(option)">
                    <span class="text-link">{{ option.id }}:</span> <span class="text-main">{{ option.name }}</span>
                </Option>
            </AutoComplete>
        </Col>
    </Row>
</template>

<script>


export default {
    name: "basic-search",
    props: {
        placeholder: String,
        sport_id  : Number, 
        value   : Object,    // {id, name, logo}
        classname : String,
        unique_tournament_id: Number,   // football season  search
        season_id: Number,
        game_id  : Number,  // 电竞
        // 定义一个名为onClick的prop，类型为Function
        onSearchApi: {
            type: Function,
            required: true // 根据需求设置是否必须
        }
    },
    components: {
    },
    data () {
        let self = (window.x = this)
        return {
            search_key: '',
            data: {
                'id': 0,
                'name': '',
                'logo': '',
            },
            datas: {},
            loading: false,
        }
    },
    methods: {
        requestApi(search_key){
            let self = this;
            self.loading = true;
            let params = {
                sport_id: self.sport_id,
                unique_tournament_id: self.unique_tournament_id,
                season_id: self.season_id,
                search_key,
                game_id: self.game_id,
            }
            self.onSearchApi(params).then(response => {
                if (response.data.code == 0) {
                    self.datas = response.data.data.list;
                } else {
                    this.$Message.error(response.data.msg);
                }
            })
            self.loading = false;
        },

        doSearch (value) {
            let self = this;
            // console.log("PLAYER SEARCH:", value,  self.data.name);
            if (value && (value !== self.data.name)){
                self.requestApi(value);
            }else if (value && ( value === self.data.name)){
                self.datas = {}
                self.datas [self.data.id]= self.data
            } else {
                self.doClear();
            }
        },
        doClear(){
            let self = this;
            self.data = {
                'id': 0,
                'name': '',
                'logo': '',
            };
            self._emit();
            self.search_key = self.data.name;
        },
        
        // end
        onChange(search_key){
            let self = this;
            // console.log("onchange -> ", search_key);
            self.$unit.debounce( () => {
                self.doSearch(search_key);
            }, 300, 'search_honor')
        },
        onClicked(data){
            // console.log("onClicked(option)", option)
            let self = this;
            self.data = data;
            self._emit();
            self.search_key = self.data.name;
        },
        // end
        _emit(){
            this.$emit('input', this.data);
            this.$emit('on-search', this.data);
        },
        // end
        blur(){
            // 失去焦点时触发
            let self = this;
            if (!self.search_key && self.data.name){
                self.doClear();
            }else{
                self.search_key = self.data.name;
            }
        },
        // end
        focus(){
            let self = this;
            self.requestApi("");
        },
        // end
    },
    mounted () {
    },
    watch: {
        'value': {
            handler: function(value){
                this.data = value;
                this.search_key = value.name;
            },
            deep: true,
        },
        // end 
    },
    computed: {
    }
}
</script>
<style scoped>
    /* @import "search.css" */
</style>